import * as React from 'react';
import { Tooltip, TooltipProps } from 'ui/common/tooltip/tooltip';

interface ConditionalTooltipProps extends TooltipProps {
  show: boolean;
  children: React.ReactNode;
}

export function ConditionalTooltip({ show, children, className, ...props }: ConditionalTooltipProps) {
  return show ? <Tooltip className={className} {...props}>{children}</Tooltip> : <div className={className}>{children}</div>;
}
